import { Scope } from '@pubstack/common/src/scope'
import { sortByName } from '@pubstack/common/src/sort'
import { useQuery } from './api-client'

export const useScopes = () => {
  return useQuery<Scope[]>({ url: '/scopes', keys: ['scopes'], select: sortByName })
}
